import React from 'react';
import SectionHeader from '../../common/SectionHeader';
import OtherSkill from './OtherSkill';

import { ReactComponent as BackgroundImage } from '../../assets/logo_infinity.svg';


import { ReactComponent as MobileAppsImage } from '../../assets/skills/mobile_apps_sm.svg';
import { ReactComponent as BackendImage } from '../../assets/skills/backend_sm.svg';
import { ReactComponent as GraphicsImage } from '../../assets/skills/graphics_sm.svg';
import { ReactComponent as ProjectManagementImage } from '../../assets/skills/project_management_sm.svg';
import { routeIds } from '../../i18n/routes';
import { useI18n } from '../../i18n/I18nContext';

function OtherSkills({mainSkill}) {
  const { pathFor, t } = useI18n();
  const allSkills = [
    {
      id: "mobile-apps",
      image: <MobileAppsImage data-ambient className="skill-art motion-art mx-auto" />,
      title: t("expertise.mobileApps.heading"),
      description: t("expertise.mobileApps.intro"),
      href: pathFor(routeIds.mobileApps),
    },
    {
      id: "back-end",
      image: <BackendImage data-ambient className="skill-art motion-art mx-auto" />,
      title: t("expertise.backend.heading"),
      description: t("expertise.backend.intro"),
      href: pathFor(routeIds.backend),
    },
    {
      id: "graphics",
      image: <GraphicsImage data-ambient className="skill-art motion-art mx-auto" />,
      title: t("expertise.graphics.heading"),
      description: t("expertise.graphics.intro"),
      href: pathFor(routeIds.graphics),
    },
    {
      id: "project-management",
      image: <ProjectManagementImage data-ambient className="skill-art motion-art mx-auto" />,
      title: t("expertise.projectManagement.heading"),
      description: t("expertise.projectManagement.intro"),
      href: pathFor(routeIds.projectManagement),
    }
  ];

  const allOtherSkills = allSkills.filter(skill => skill.id !== mainSkill).map((skill, index) => {
    const first = index === 0;
    const last = index === allSkills.length - 2;

    return (
      <OtherSkill
        image={skill.image}
        title={skill.title}
        description={skill.description}
        href={skill.href}
        corners={`${first ? "top-left bottom-left bottom-right" : (last ? "top-left top-right bottom-right": "top-left top-right bottom-left bottom-right")}`}
      />);
  });
  
  return (
    <section id="autres-expertises" className="relative bg-primary-500/40 content-center overflow-x-clip py-[5rem] px-10">
      <BackgroundImage className="absolute text-white right-[-445px] w-[609px] h-[314px] bottom-0 transform translate-y-1/2 z-20" />
      <div className="relative max-w-[1200px] mx-auto z-20">
        <SectionHeader title={t("expertise.common.otherTitle")} subtitle={t("expertise.common.otherSubtitle")} />
        <div className="hidden bg-accent"></div>
        <div className="hidden bg-primary-300"></div>
        <div className="flex flex-wrap justify-center py-[2.03125rem] mx-[-37.5px] w-[calc(100% + 75px)]">
          {allOtherSkills}
        </div>
        <div className="flex justify-center w-full font-bold text-dark pb-[1.625rem]">{t("expertise.common.otherQuestion")}</div>
        <div className="flex justify-center w-full">
          <a className="motion-button bg-accent text-white text-center font-bold rounded-full uppercase py-[1.25rem] px-[60px] transition duration-300 hover:opacity-50" href={pathFor(routeIds.contact)}>{t("common.contactUs")}</a>
        </div>
      </div>
    </section>
  );
}

export default OtherSkills;
